/* WalkByFaith Dutch storefront labels for Dawn, source variant values unchanged. */
(() => {
"use strict";
if(window.__wbfDawnDutch)return;window.__wbfDawnDutch=true;
const type=String(document.getElementById("wbf-product-gallery-data")?.textContent||"").match(/"productType"\s*:\s*"([^"]+)"/)?.[1]?.toLowerCase()||"";
const words={
 "Color":"Kleur","Colour":"Kleur","Depth":"Dikte","Surface":"Afwerking",
 "White":"Wit","Black":"Zwart","Red":"Rood","Blue":"Blauw","Pink":"Roze","Orange":"Oranje",
 "Gray":"Grijs","Grey":"Grijs","Light Blue":"Lichtblauw","Light Pink":"Lichtroze",
 "Dark Navy":"Donker marineblauw","Navy":"Marineblauw","Dark Green":"Donkergroen","Forest Green":"Bosgroen",
 "Military Green":"Legergroen","Sport Grey":"Sportgrijs","Dark Heather":"Donker gemêleerd grijs",
 "Ash":"Asgrijs","Charcoal":"Antraciet","Maroon":"Bordeauxrood","Royal":"Koningsblauw",
 "Sapphire":"Saffierblauw","Sand":"Zand","Natural":"Naturel","Dark Chocolate":"Donkerbruin",
 "Daisy":"Geel","Heliconia":"Felroze","One size":"Eén maat","Matte":"Mat",
 "Rose Gold":"Roségoud","Rose Goud":"Roségoud","Gold":"Goud","Silver":"Zilver",
 "Heather Grey":"Gemêleerd grijs","Heather Gray":"Gemêleerd grijs","Forest":"Bosgroen",
 "Light Green":"Lichtgroen","Heather":"Gemêleerd","Burgundy":"Bordeauxrood"
};
const canvas={
 "10x8":"25 × 20 cm (Plank / bureau formaat)",
 "16x12":"40 × 30 cm (Meest gekozen)",
 "20x16":"50 × 40 cm (Standaard muurformaat)",
 "24x20":"60 × 50 cm (Middelgroot statement)",
 "30x24":"75 × 60 cm (Groot wandformaat)",
 "40x30":"100 × 75 cm (Extra groot / eyecatcher)"
};
const bagSizes={"13x13":"33 × 33 cm","16x16":"41 × 41 cm","18x18":"46 × 46 cm"};
const trim=x=>String(x||"").trim();
function productType(el){
 const cart=el.closest(".cart-item,.cart-drawer .cart-item");
 if(cart){
  const name=cart.querySelector(".cart-item__name")?.textContent?.toLowerCase()||"";
  if(/canvas|wall.?art/.test(name))return "canvas";
  if(/telefoonhoesje|phone case/.test(name))return "phone";
  if(/tote|tas\b/.test(name))return "bag";
  if(/shirt|hoodie|sweat/.test(name))return "clothing";
 }
 return type;
}
function sizeLabel(el){
 const t=productType(el);
 return /phone|telefoon/.test(t)?"Telefoonmodel":/canvas|wall.?art/.test(t)?"Afmeting":/bag|tote|tas/.test(t)?"Formaat":"Maat";
}
function single(value,el){
 const v=trim(value);
 if(!v)return v;
 if(v==="Size")return sizeLabel(el);
 if(v==="Size:")return sizeLabel(el)+":";
 if(words[v])return words[v];
 const combined=v.match(/^(Size|Color|Colour|Depth|Surface)\s*([-–—:])\s*(.+)$/i);
 if(combined){const name=combined[1].toLowerCase()==="size"?sizeLabel(el):(words[combined[1]]||combined[1]);return name+" "+combined[2]+" "+single(combined[3],el)}
 const norm=v.replace(/[“”″ʺ]/g,'"').replace(/[’‘]/g,"'");
 const match=norm.match(/^(\d+)\s*["']{0,3}\s*[x×]\s*(\d+)\s*["']{0,3}(?:\s*\(Horizontal\))?$/i);
 if(match){
   const key=match[1]+"x"+match[2],t=productType(el);
   if(canvas[key] && /canvas|wall.?art/.test(t))return canvas[key];
   if(bagSizes[key] && /bag|tote|tas/.test(t))return bagSizes[key];
 }
 return v;
}
function convert(raw,el){
 const value=trim(raw);if(!value)return raw;
 const isCart=!!el.closest(".cart-item,.cart-drawer");
 const bits=isCart&&value.includes(" / ")?value.split(" / "):[value];
 const converted=bits.filter(bit=>!(isCart && /canvas|wall.?art/.test(productType(el)) && /^1\.25\s*["″]$/.test(trim(bit)))).map(x=>single(x,el)).join(" / ");
 if(value===converted)return raw;
 return (raw.match(/^\s*/)?.[0]||"")+converted+(raw.match(/\s*$/)?.[0]||"");
}
function visit(root){
 const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
 let node;
 while(node=walker.nextNode()){
   if(node.parentElement?.closest("script,style,textarea,svg,[contenteditable],.visually-hidden"))continue;
   const next=convert(node.nodeValue,node.parentElement);
   if(next!==node.nodeValue)node.nodeValue=next;
 }
}
function hideDepth(){
 if(!/canvas|wall.?art/.test(type))return;
 document.querySelectorAll("variant-selects .product-form__input").forEach(group=>{
   const select=group.querySelector('select[name="options[Depth]"]');
   const radios=group.querySelectorAll('input[type="radio"][name="Depth"]');
   if((select&&select.options.length===1)||radios.length===1)group.style.display="none";
 });
}
const selector=[
 "variant-selects .form__label","variant-selects label",
 "variant-selects select option","variant-selects [data-selected-value]",
 ".cart-item .product-option",".cart-drawer .product-option",
 ".card__swatches-container .color-swatch__label"
].join(",");
function apply(){document.querySelectorAll(selector).forEach(visit);hideDepth()}
let scheduled=false;
function schedule(){
 if(scheduled)return;scheduled=true;
 requestAnimationFrame(()=>{scheduled=false;apply()});
}
function init(){
 apply();
 document.addEventListener("change",e=>{if(e.target?.closest?.("variant-selects"))schedule()},true);
 new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,characterData:true});
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
})();